import { Action } from '@ngrx/store';
import { Session, UsuarioDarAvisoExpiracionClave, UsuarioExpiracionClave } from 'src/app/session/store/session';
import { CambioClaveMotivoErrorEnum } from './session.selectors';




export enum SessionActionTypes {
	AfterLoginRequested = '[AfterLogin Component] Post Login Requested',

	SessionCreateRequested = '[Start Component] Session Create Requested',
	SessionCreateLoaded = '[Session API] Session Create Loaded',
	SessionCreateCancelled = '[Session API] Session Create Cancelled',

	SessionOpenRequested = '[Session Component] Session Open Requested',
	SessionOpenLoaded = '[Session API] Session Open Loaded',
	SessionOpenCancelled = '[Session API] Session Open Cancelled',
	SessionExpirationRequested = "[Session API] Session Expiration Requested",
	SessionCloseRequested = '[Header Component] Session Close Requested',
	SessionDisableRequested = '[Cambio Clave Component] Session Disable Requested',

	RefreshTokenRequested = "[Auth Interceptor] Refresh Token Requested",
	ValidateSessionRequested = "[Auth Guard] Validate Session Requested",
	ValidateSessionDone = '[Session API] Validate Session Done',
	RefreshSessionRequested = '[Session API] Refresh Session Requested',
	RefreshLegacySessionRequested = '[Session API] Refresh Legacy Session Requested',

	XTargetUpdated = "[Acceso Interceptor] XTarget Updated",
	XViaUpdated = "[Acceso Interceptor] XVia Updated",
	VerifyDateRequested = "[StartSession Component] Verify Date Requested",
	VerifyDateDone = "[Session API] Verify Date Done",

	PostponePassExpirationRequested = "[ExpiracionClave Component] Postpone Pass Expiration Requested",
	PostponePassExpirationLoaded = "[Session API] Postpone Pass Expiration Loaded",
	PostponePassExpirationCancelled = "[Session API] Postpone Pass Expiration Cancelled",
	CambioClaveRequested = '[CambioClave Component] Cambio Clave Requested',
	CambioClaveDone = '[CambioClave API] Cambio Clave Done',
	CambioClaveCancelled = '[CambioClave API] Cambio Clave Cancelled'
}

export class AfterLoginRequested implements Action {
	readonly type: string = SessionActionTypes.AfterLoginRequested;
	constructor( public payload: { idPersonaInstitucional?: string, useTokenAcceso?: boolean } ) {
	}
}

// SessionCreate related actions
export class SessionCreateRequested implements Action {
	readonly type: string = SessionActionTypes.SessionCreateRequested;
	constructor() {
	}
}

export class SessionCreateLoaded implements Action {
	readonly type: string = SessionActionTypes.SessionCreateLoaded;
	constructor( public payload: { session: Session } ) {
	}
}

export class SessionCreateCancelled implements Action {
	readonly type: string = SessionActionTypes.SessionCreateCancelled;
	constructor() {
	}
}

// SessionOpen related actions
export class SessionOpenRequested implements Action {
	readonly type: string = SessionActionTypes.SessionOpenRequested;
	constructor() {
	}
}

export class SessionOpenLoaded implements Action {
	readonly type: string = SessionActionTypes.SessionOpenLoaded;
	constructor() {
	}
}

export class SessionOpenCancelled implements Action {
	readonly type: string = SessionActionTypes.SessionOpenCancelled;
	constructor() {
	}
}

export class SessionExpirationRequested implements Action {
	readonly type: string = SessionActionTypes.SessionExpirationRequested;
	constructor() {
	}
}

// RefreshStorage related actions
export class RefreshTokenRequested implements Action {
	readonly type: string = SessionActionTypes.RefreshTokenRequested;
	constructor( public payload: { tokenSesion: string } ) {
	}
}

export class ValidateSessionRequested implements Action {
	readonly type: string = SessionActionTypes.ValidateSessionRequested;
	constructor() {
	}
}

export class ValidateSessionDone implements Action {
	readonly type: string = SessionActionTypes.ValidateSessionDone;
	constructor( public payload: { valid: boolean } ) {
	}
}

export class RefreshSessionRequested implements Action {
	readonly type: string = SessionActionTypes.RefreshSessionRequested;
	constructor( public payload: { idPersonaInstitucional: string, phpSession: string, ce: string, session: string } ) {
	}
}

export class RefreshLegacySessionRequested implements Action {
	readonly type: string = SessionActionTypes.RefreshLegacySessionRequested;
	constructor() {
	}
}

export class SessionCloseRequested implements Action {
	readonly type: string = SessionActionTypes.SessionCloseRequested;
	constructor() {
	}
}

export class SessionDisableRequested implements Action {
	readonly type: string = SessionActionTypes.SessionDisableRequested;
	constructor() {
	}
}

export class XTargetUpdated implements Action {
	readonly type: string = SessionActionTypes.XTargetUpdated;
	constructor( public payload: { connectionType: string } ) {
	}
}

export class XViaUpdated implements Action {
	readonly type: string = SessionActionTypes.XViaUpdated;
	constructor( public payload: { sedeType: string } ) {
	}
}

export class VerifyDateRequested implements Action {
	readonly type: string = SessionActionTypes.VerifyDateRequested;
	constructor() {
	}
}

export class VerifyDateDone implements Action {
	readonly type: string = SessionActionTypes.VerifyDateDone;
	constructor( public payload: { validDate: boolean } ) {
	}
}


// Password Expiration and Cambio Clave related actions
export class PostponePassExpirationRequested implements Action {
	readonly type: string = SessionActionTypes.PostponePassExpirationRequested;
	constructor() {
	}
}

export class PostponePassExpirationLoaded implements Action {
	readonly type: string = SessionActionTypes.PostponePassExpirationLoaded;
	constructor( public payload: { darAviso: UsuarioDarAvisoExpiracionClave } ) {
	}
}

export class PostponePassExpirationCancelled implements Action {
	readonly type: string = SessionActionTypes.PostponePassExpirationCancelled;
	constructor() {
	}
}

export class CambioClaveRequested implements Action {
	readonly type: string = SessionActionTypes.CambioClaveRequested;
	constructor( public payload: { claveActual: string, claveNueva: string } ) {
	}
}

export class CambioClaveDone implements Action {
	readonly type: string = SessionActionTypes.CambioClaveDone;
	constructor( public payload: { usuarioExpiracionClave: UsuarioExpiracionClave } ) {
	}
}

export class CambioClaveCancelled implements Action {
	readonly type: string = SessionActionTypes.CambioClaveCancelled;
	constructor( public payload: { motivo: CambioClaveMotivoErrorEnum }) {
	}
}


export type SessionActions = SessionCreateRequested | SessionCreateLoaded | SessionCreateCancelled |
	SessionOpenRequested | SessionOpenLoaded |
	SessionOpenCancelled | SessionExpirationRequested |	SessionCloseRequested | SessionCloseRequested | 
	RefreshTokenRequested | ValidateSessionRequested | ValidateSessionDone | RefreshSessionRequested |
	RefreshLegacySessionRequested | XTargetUpdated | XViaUpdated | VerifyDateRequested | VerifyDateDone |
	PostponePassExpirationLoaded | PostponePassExpirationLoaded | PostponePassExpirationCancelled |
	CambioClaveRequested | CambioClaveDone | CambioClaveCancelled;
